import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Destinations from './components/Destinations';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import ProgramsPage from './components/ProgramsPage';
import Tours from './components/TourPage';
import { EducationForm } from './components/education-form';
import CourseCards from './components/course-cards';
import { FormProvider } from './components/form-provider';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminApplications from './components/admin/AdminApplications';
import AICertificationPage from './components/AICertificationPage';
import CorporateTravelPage from './components/CorporateTravelPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <FormProvider>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/destination" element={<Destinations />} />
          <Route path="/aboutus" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/programs" element={<ProgramsPage/>} />
          <Route path="/ai-certification" element={<AICertificationPage/>} />
          <Route path="/corporate-travel" element={<CorporateTravelPage/>} />
          <Route path="/eligibility" element={<EducationForm/>} />
          <Route path="/tours/:id" element={<Tours/>} />  
          <Route path="/course" element={<CourseCards/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/signup" element={<Signup/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/adminApplicationUni" element={<AdminApplications />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
        </Routes>
      </FormProvider>
    </AuthProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

